import { ProposalInfoPage } from "@client/components/round/allocator/EvaluablePage/ProposalInfoPage";
import LoadingSpinner from "@client/components/utils/LoadingSpinner";
import ThemeSelector from "@client/components/utils/ThemeSelector";
import useLoader from "@client/components/utils/useLoader";
import { trpc } from "@client/trpc";
import { Proposal } from "@engine/round/aggregate";
import { useCallback } from "react";
import type { FilteredProposalForm } from "server/routes/getProposal";

export function ViewProposalPage({
  params,
}: {
  params: { roundId: string; proposalId: string };
}) {
  const getProposal = useCallback(
    () => trpc().getProposal.query(params),
    [params],
  );
  const proposalLoading = useLoader(getProposal);

  return (
    <div className="h-full min-h-screen">
      <div className="fixed top-2 right-2">
        <ThemeSelector />
      </div>
      <div className="container mx-auto px-8 py-16">
        <h1 className="text-2xl mb-12">Proposal Viewing Page</h1>

        {proposalLoading.type === "success" && (
          <ProposalView
            proposal={proposalLoading.data.proposal}
            filteredProposalForm={proposalLoading.data.filteredProposalForm}
          />
        )}
        {proposalLoading.type === "loading" && <LoadingSpinner />}
        {proposalLoading.type === "error" && (
          <div>{proposalLoading.error.message}</div>
        )}
      </div>
    </div>
  );
}

function ProposalView({
  proposal,
  filteredProposalForm,
}: {
  proposal: Proposal;
  filteredProposalForm: FilteredProposalForm;
}) {
  return (
    <div>
      <h3 className="text-xl text-stone-700 dark:text-stone-300 mb-6">
        {proposal.longname}
      </h3>
      <ProposalInfoPage
        proposal={proposal}
        filteredProposalForm={filteredProposalForm}
      />
    </div>
  );
}
